// extracted by mini-css-extract-plugin
export var activeFilterButton = "_s0-c";
export var backButton = "_s0-4";
export var backIcon = "_s0-5";
export var chevronShortcut = "_s0-6";
export var container = "_s0-1";
export var editor = "_s0-8";
export var editorWrapper = "_s0-7";
export var prefix = "_s0-2";
export var searchIcon = "_s0-3";
export var suffix = "_s0-9";
export var suffixContent = "_s0-a";
export var suffixText = "_s0-b";
export var wrapper = "_s0-0";